/**
 * Official one-for-one course equivalencies that degree audits, planners, and
 * prerequisite checks must treat as the same requirement slot. Codes are
 * 8-digit base IDs (school + subject + number).
 *
 * CS 120 (Introduction to Programming) is deliberately absent: the department
 * grants no CS major credit for it, so it is not equivalent to CS 111.
 */
export const COURSE_EQUIVALENCES = [
  {
    courses: ['01198111', '01198121'],
    effectiveTerm: 'Spring 2027',
    source: 'https://www.cs.rutgers.edu/academics/undergraduate/new-introductory-computer-science-course-sequence',
    retrievedAt: '2026-10-02',
  },
  {
    courses: ['01198112', '01198122'],
    effectiveTerm: 'Spring 2027',
    source: 'https://www.cs.rutgers.edu/academics/undergraduate/new-introductory-computer-science-course-sequence',
    retrievedAt: '2026-10-02',
  },
] as const;

const digits = (code: string) => String(code || '').replace(/[^0-9]/g, '');

const classByCode = new Map<string, string>();
for (const group of COURSE_EQUIVALENCES) {
  for (const code of group.courses) classByCode.set(code, group.courses[0]);
}

/** Stable key shared by every course in an equivalence class (the code itself when it has none). */
export function courseEquivalenceKey(code: string): string {
  const norm = digits(code);
  return classByCode.get(norm) ?? classByCode.get(`01${norm}`) ?? norm;
}

/** Other base IDs that satisfy the same slot as `code`, excluding `code`. */
export function equivalentCourseCodes(code: string): string[] {
  const key = courseEquivalenceKey(code);
  const group = COURSE_EQUIVALENCES.find(item => item.courses[0] === key);
  const norm = digits(code);
  return group ? group.courses.filter(member => member !== norm && member !== `01${norm}`) : [];
}
